// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carrierUploadForm {
  margin: 20px auto 40px;
  background: #fff;
  padding: 25px 20px;
  border-radius: 10px;
  max-width: 1000px;
  width: 100%;
}
#contents.carrierUploadFormWrapper {
  display: block;
}
.carrierUploadFormWrapper .breadCrumb__wrapper {
  padding: 10px 0px 0;
  max-width: 1000px;
  margin: 0 auto;
}
.carrierUploadForm--heading {
  font-size: 20px;
  margin-bottom: 20px;
}
.carrierUploadForm--mandatoryField {
  color: #c91b1b;
  margin-left: 2px;
}
.carrierUploadForm--button {
  width: 475px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  height: 48px;
  line-height: 48px;
  margin-top: 55px;
  margin-bottom: 30px;
  padding: 0 20px;
  font-size: 16px;
}
.carrierUploadForm--button:disabled,
.carrierUploadForm--button:disabled:hover {
  opacity: 0.6;
  background: #1984bc;
}
.carrierUploadFormDropdown {
  width: 100%;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.carrierUploadFormDropdown--btn {
  padding: 12px 15px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  color: #1984bc;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
}
.carrierUploadFormDropdown--selectedValues {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
}
.carrierUploadFormDropdown--btnIcon {
  height: 8px;
  width: 8px;
  border-left: 1px solid #1984bc;
  border-bottom: 1px solid #1984bc;
  transform: rotate(-45deg);
  transition: all 0.4s;
  position: relative;
  top: 4px;
}
.carrierUploadFormDropdown--btnIcon__rotate {
  transform: rotate(135deg);
}
.carrierUploadFormDropdown--content {
  position: absolute;
  top: 100%;
  padding: 10px 0;
  background: #fff;
  box-shadow: 3px 3px 10px 6px rgba(0, 0, 0, 0.06);
  color: #333;
  left: 0;
  width: 100%;
  font-size: 14px;
  color: #222222;
  z-index: 1;
  border-radius: 6px;
  max-height: 165px;
  overflow-y: auto;
}
.carrierUploadFormDropdown--item {
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.4s;
  display: block;
  line-height: 1.2;
}
.carrierUploadFormDropdown--item.carrierUploadFormDropdown--selected {
  color: #1984bc;
}
.carrierUploadFormDropdown--item:hover {
  background: #f8f9fa;
}
.label-value-wrapper
  input[type='checkbox'].carrierUploadFormDropdown--itemCheckbox {
  margin-left: 0;
  margin-right: 8px;
  cursor: pointer;
}
.carrierUploadForm--customUpload {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.carrierUploadForm-fileName {
  width: calc(100% - 160px);
  display: inline-block;
  height: 44px;
  line-height: 44px;
  padding: 0 15px;
  border: 1px solid #d6d6d6;
  font-size: 14px;
  color: #1984bc;
  border-radius: 6px;
}
.carrierUploadForm-fileBrowse {
  background: #e6f2f8;
  padding: 5px;
  display: inline-block;
  color: #0177b5;
  font-size: 14px;
  font-weight: 600;
  width: 150px;
  border: none;
  height: 44px;
  line-height: 44px;
  padding: 0 20px;
  border-radius: 6px;
  text-align: center;
}
.carrierUpload-err {
  color: #c91b1b;
  margin: 8px 0;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/carrierUploadForm/carrierUpload.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,WAAW;EACX,OAAO;EACP,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB","sourcesContent":[".carrierUploadForm {\n  margin: 20px auto 40px;\n  background: #fff;\n  padding: 25px 20px;\n  border-radius: 10px;\n  max-width: 1000px;\n  width: 100%;\n}\n#contents.carrierUploadFormWrapper {\n  display: block;\n}\n.carrierUploadFormWrapper .breadCrumb__wrapper {\n  padding: 10px 0px 0;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n.carrierUploadForm--heading {\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n.carrierUploadForm--mandatoryField {\n  color: #c91b1b;\n  margin-left: 2px;\n}\n.carrierUploadForm--button {\n  width: 475px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  height: 48px;\n  line-height: 48px;\n  margin-top: 55px;\n  margin-bottom: 30px;\n  padding: 0 20px;\n  font-size: 16px;\n}\n.carrierUploadForm--button:disabled,\n.carrierUploadForm--button:disabled:hover {\n  opacity: 0.6;\n  background: #1984bc;\n}\n.carrierUploadFormDropdown {\n  width: 100%;\n  position: relative;\n  user-select: none;\n}\n.carrierUploadFormDropdown--btn {\n  padding: 12px 15px;\n  display: flex;\n  align-content: center;\n  justify-content: space-between;\n  color: #1984bc;\n  cursor: pointer;\n  font-size: 14px;\n  border: 1px solid #d6d6d6;\n  border-radius: 6px;\n}\n.carrierUploadFormDropdown--selectedValues {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.5;\n}\n.carrierUploadFormDropdown--btnIcon {\n  height: 8px;\n  width: 8px;\n  border-left: 1px solid #1984bc;\n  border-bottom: 1px solid #1984bc;\n  transform: rotate(-45deg);\n  transition: all 0.4s;\n  position: relative;\n  top: 4px;\n}\n.carrierUploadFormDropdown--btnIcon__rotate {\n  transform: rotate(135deg);\n}\n.carrierUploadFormDropdown--content {\n  position: absolute;\n  top: 100%;\n  padding: 10px 0;\n  background: #fff;\n  box-shadow: 3px 3px 10px 6px rgba(0, 0, 0, 0.06);\n  color: #333;\n  left: 0;\n  width: 100%;\n  font-size: 14px;\n  color: #222222;\n  z-index: 1;\n  border-radius: 6px;\n  max-height: 165px;\n  overflow-y: auto;\n}\n.carrierUploadFormDropdown--item {\n  padding: 10px 15px;\n  cursor: pointer;\n  transition: all 0.4s;\n  display: block;\n  line-height: 1.2;\n}\n.carrierUploadFormDropdown--item.carrierUploadFormDropdown--selected {\n  color: #1984bc;\n}\n.carrierUploadFormDropdown--item:hover {\n  background: #f8f9fa;\n}\n.label-value-wrapper\n  input[type='checkbox'].carrierUploadFormDropdown--itemCheckbox {\n  margin-left: 0;\n  margin-right: 8px;\n  cursor: pointer;\n}\n.carrierUploadForm--customUpload {\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.carrierUploadForm-fileName {\n  width: calc(100% - 160px);\n  display: inline-block;\n  height: 44px;\n  line-height: 44px;\n  padding: 0 15px;\n  border: 1px solid #d6d6d6;\n  font-size: 14px;\n  color: #1984bc;\n  border-radius: 6px;\n}\n.carrierUploadForm-fileBrowse {\n  background: #e6f2f8;\n  padding: 5px;\n  display: inline-block;\n  color: #0177b5;\n  font-size: 14px;\n  font-weight: 600;\n  width: 150px;\n  border: none;\n  height: 44px;\n  line-height: 44px;\n  padding: 0 20px;\n  border-radius: 6px;\n  text-align: center;\n}\n.carrierUpload-err {\n  color: #c91b1b;\n  margin: 8px 0;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
